import React from "react";
import Modal from "react-bootstrap/Modal";

const InvoiceErrorPopup = (props) => {
  return (
    <Modal
      show={props.showError}
      onHide={props.onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{
        zIndex: "9999",
        textAlign: "center",
        background: "#F2F2F2 0% 0% no-repeat padding-box",
        opacity: 0.95,
      }}
      className="error-modal"
      id="task-error-modal-id"
    >
      <div className="task-error-modal" style={{ fontSize: "var(--responsive-font-16)" }}>
        <div>
          <p className="ascpls pop-up-text-add" style={{ fontSize: "18px" }}>
            {props.attachMessage}
          </p>
        </div>
        <div style={{ marginTop: "2rem", display: "flex" }}>
          <button
            className="task-error-cancel-add"
            style={{ backgroundColor: "transparent" }}
            onClick={() => {
              props.setShowError && props.setShowError(false);
              props.onConfirmaion && props.onConfirmaion(false);
            }}
          >
            OK
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default InvoiceErrorPopup;
